import Vue from 'vue'
import Router from 'vue-router'
// eslint-disable-next-line no-unused-vars
import Layout from '@/layout'
// eslint-disable-next-line no-unused-vars
import Father from '@/layout/father'
Vue.use(Router)
/* Layout */

export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/index/index'),
        name: 'index',
        meta: { title: '概况' }
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    meta: { hidden: true, title: '登录' }
  },
  {
    path: '/signature',
    component: () => import('@/views/tools/signature'),
    meta: { hidden: true, title: '验签工具' }
  },
  {
    path: '/branchCode',
    component: () => import('@/views/tools/branchCode'),
    meta: { hidden: true, title: '支行查询工具' }
  },
  {
    path: '/mccCode',
    component: () => import('@/views/tools/mccCode'),
    meta: { hidden: true, title: 'mcc查询工具' }
  },
  {
    path: '/areaCode',
    component: () => import('@/views/tools/areaCode'),
    meta: { hidden: true, title: '地区码开发工具' }
  },
  {
    path: '/addChainMerchant',
    name: 'addChainMerchant',
    component: () => import('@/views/merchant/merchantManage/addChainMerchant'),
    meta: { hidden: true, title: '新增连锁商户' }
  },
  {
    path: '/storeManage',
    name: 'storeManage',
    component: () => import('@/views/merchant/merchantSoftwareService/storeManage/index'),
    meta: { hidden: true, title: '门店管理' }
  },
  {
    path: '/chain-shop-list',
    name: 'chain-shop-list',
    component: () => import('@/views/merchant/chain-shop-manage/chain-shop-list'),
    meta: { hidden: true, title: '门店管理' }
  },
  {
    path: '/addChainShop',
    name: 'addChainShop',
    component: () => import('@/views/merchant/chain-shop-manage/addChainShop'),
    meta: { hidden: true, title: '门店管理' }
  },
  {
    path: '/chainDetails',
    name: 'chainDetails',
    component: () => import('@/views/merchant/chain-shop-manage/chainDetails'),
    meta: { hidden: true, title: '门店管理' }
  }

]

export const asyncRoutes = []

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
export default router
